<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>账户</span>
            <div>
              <el-button type="primary" size="small" @click="_goBack">
                <i class="el-icon-close"></i> 返回
              </el-button>
            </div>
          </div>
          <div class="table-container">
            <el-table
              :data="shopVipUserAccountInfo.shopAccounts"
              style="width: 100%"
              border
              stripe
            >
              <el-table-column prop="vipAcctId" label="账户编号" align="center"></el-table-column>
              <el-table-column prop="acctName" label="账户名称" align="center"></el-table-column>
              <el-table-column prop="acctTypeName" label="账户类型" align="center"></el-table-column>
              <el-table-column prop="amount" label="账户金额" align="center"></el-table-column>
              <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
            </el-table>
            <el-pagination
              class="pagination-container"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              :total="shopVipUserAccountInfo.total"
              layout="total, prev, pager, next, jumper"
            ></el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryShopVipAccount } from '@/api/goods/shopVipUserAccountApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ShopVipUserAccount',
  data() {
    return {
      shopVipUserAccountInfo: {
        shopAccounts: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          state: '',
          shopId: '',
          communityName: '',
          vipId: ''
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this.shopVipUserAccountInfo.conditions.vipId = this.$route.query.vipId
    this.shopVipUserAccountInfo.conditions.shopId = getShopId().shopId
    console.log(this.shopVipUserAccountInfo.moreCondition)
    this._listshopVipUserAccounts(this.currentPage, this.pageSize)
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this._listshopVipUserAccounts(this.currentPage, this.pageSize)
    },
    async _listshopVipUserAccounts(page, rows) {
      this.shopVipUserAccountInfo.conditions.page = page
      this.shopVipUserAccountInfo.conditions.row = rows
      try {
        const res = await queryShopVipAccount(this.shopVipUserAccountInfo.conditions)
        this.shopVipUserAccountInfo.total = res.total
        this.shopVipUserAccountInfo.records = res.records
        this.shopVipUserAccountInfo.shopAccounts = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
.table-container {
  margin-top: 20px;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>